import { useTranslation } from 'services/i18n'
import { MessageResourceType } from 'types/MessageResourceType'

import type { FC, KeyboardEvent, PropsWithChildren } from 'react'

type Props = PropsWithChildren & {
  onClick?: VoidFunction
  resourceType: MessageResourceType
}

export const MessageResourceTagClickEventWrapper: FC<Props> = ({ children, onClick, resourceType }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'message_resources.open_modal' })

  const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' && onClick) onClick()
  }

  if (!onClick) return children

  return (
    <div
      aria-label={t(resourceType)}
      onClick={onClick}
      className="cursor-pointer"
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  )
}
